import './App.css';
import {  Route, BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import Login from './pages/login/login';
import NavHeader from './pages/navHeader/header';
import LayoutHome from './pages/layout/layout';
import PasswordFind from './pages/passwordFind/passwordFind'
import Momey from './pages/navHeader/momey';
import supplierQuotation from './pages/supplierQuotation';
import carrierVer from './pages/supplierQuotation/carrierVer';
import checkRoleAndUpdate from './utils/loginCheck';
import i18n from './utils/i18n';
import { performanceInit } from './utils/performances';
import { hrefSSO, getQueryVariable } from './utils/utils';


function App(history) {

//埋点
performanceInit();
// 检查登录权限,是否存在从url切换
checkRoleAndUpdate().catch(() => {
  // do noting
});
const menuCode = getQueryVariable('menuCode');
hrefSSO();
if(menuCode){
  return (
    <div class="div-body">
      <div class="loader"></div>
    </div>
  );
}else{
  return (
    <I18nextProvider i18n={i18n}>
      <LayoutHome history={history.history}>
        <BrowserRouter>
          <Route  component={NavHeader} path='/' exact ></Route>
          <Route  component={Login} path='/login' exact ></Route>
          <Route  component={NavHeader} path='/home' exact ></Route>
          <Route  component={PasswordFind} path='/passwordFind' exact ></Route>
          <Route  component={Momey} path='/momey' exact ></Route>
          <Route  component={carrierVer} path='/carrierVerification' exact ></Route>
          <Route  component={supplierQuotation} path='/carrierQuo' exact ></Route>
        </BrowserRouter>
      </LayoutHome>
    </I18nextProvider>
    );
}
}

export default App;
